/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { createElement } from "react";
import SVG from "react-inlinesvg";

import FakturinoLogoSVG from "@krea/customer-features/images/svg/logo/fakturino-krea-logo.svg";
import KreditaLogoSVG from "@krea/customer-features/images/svg/logo/kredita-logo.svg";
import LogoSVG from "@krea/customer-features/images/svg/logo/logo.svg";
import { settings } from "@krea/customer-features/settings";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";
import { CountryCode } from "@krea/shared/types/common";

import styles from "./Logo.module.scss";

interface ILogoProps {
  className?: string;
  href?: string;
}

// TODO: Refactor this component to use only tailwind. It has custom styles and some weird spacing that were hard to replicate in a short time.
const Logo = ({ className, href }: ILogoProps) => {
  const htmlTag = href ? "a" : "div";
  let logoSVG = "";

  switch (settings.countryCode) {
    case CountryCode.SE:
      logoSVG =
        "isOnFakturino" in settings && settings.isOnFakturino
          ? FakturinoLogoSVG
          : LogoSVG;
      break;
    case CountryCode.FI:
      logoSVG = KreditaLogoSVG;
      break;
  }

  const logoBlock = (
    <SVG className="tw-absolute tw-block tw-h-auto tw-w-full" src={logoSVG} />
  );

  const icon = (countryCode: CountryCode) => {
    switch (countryCode) {
      case CountryCode.SE:
        return styles.kreaLogo;
      case CountryCode.FI:
        return styles.kreditaLogo;
      default:
        return styles.kreaLogo;
    }
  };

  return createElement(
    htmlTag,
    {
      className: twMerge(
        styles.root,
        icon(settings.countryCode),
        "tw-block tw-relative",
        className,
      ),
      href: href,
    },
    logoBlock,
  );
};

export default Logo;
